import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { ArrowIcons, ArrowDirection } from './types';

export default /*#__PURE__*/_defineComponent({
  __name: 'RotatingArrow',
  props: {
    icon: { default: ArrowIcons.OnBoarding },
    direction: { default: ArrowDirection.Right },
    width: { default: 7 },
    height: { default: 12 }
  },
  setup(__props: any) {

const props = __props as { icon: ArrowIcons, direction: ArrowDirection, width: number, height: number }


const hasNegativeOffset = computed(() => [ArrowIcons.Filled].includes(props.icon));

return { __sfc: true,props, hasNegativeOffset }
}

})